import { MARQUEE } from "@/lib/site";

export default function Marquee() {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div
      className="relative flex overflow-hidden border-y border-slate-900/10 bg-[#f3f6fa] py-6"
      data-testid="marquee"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[#f3f6fa] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[#f3f6fa] to-transparent" />
      <div className="animate-marquee flex shrink-0 items-center gap-10 whitespace-nowrap pr-10">
        {items.map((item, i) => (
          <div key={i} className="flex items-center gap-10">
            <span className="font-display text-2xl font-bold tracking-tight text-slate-500 transition-colors hover:text-slate-900 md:text-3xl">
              {item}
            </span>
            <span className="text-blue-500/60">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
}
